module.exports = __webpack_public_path__ + "static/img/page11-bg.b6bc7d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page11-bg.png
// module id = NO5m
// module chunks = 216